import './notificationToggler.scss';

export class NotificationToggle {

    static instance = {
        template: require('./notifiationToggler.html'),
        controller: [
            NotificationToggle
        ], bindings: {
            numberOfNotifications: '=',
            showNotification: '=',
            toggleNotificationList: '=',
        },
        controllerAs: '$ctrl',
        bindToController: true,
    };

    private numberOfNotifications: number;
    private showNotification: boolean;
    private toggleNotificationList: () => void;

    $onInit(): void {
        console.log(this);
    }


}